// extracted by mini-css-extract-plugin
export var active = "NavigationDesktopContent-module--active--yKCuO";
export var group = "NavigationDesktopContent-module--group--xbvjw";
export var groupContent = "NavigationDesktopContent-module--groupContent--eQi9R";
export var navigationLink = "NavigationDesktopContent-module--navigationLink--0IThT";
export var navigationLinksTitle = "NavigationDesktopContent-module--navigationLinksTitle--D+pZ5";
export var overlay = "NavigationDesktopContent-module--overlay--jaW0+";
export var underlineLink = "NavigationDesktopContent-module--underlineLink--YyTJV";
export var wrapper = "NavigationDesktopContent-module--wrapper--V5dbm";